module.exports = __webpack_public_path__ + "static/img/Andrew-McGrath.1152059.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Andrew-McGrath.jpg
// module id = Dd4v
// module chunks = 0